import React from 'react';
import { Edit, ChevronRight, RefreshCw } from 'lucide-react';

/* ── Mobile: User Card + Stats + Switch Card ── */
const ProfileMobileHeader = ({ user, navigate
  // , setSwitchModal
}) => {
  return (
    <>
      {/* Mobile User Card */}
      <div className="profile-mobile-user">

        {user.avatar && (
          <img
            src={user.avatar}
            alt={user.name}
            className="profile-avatar"
            onError={(e) => {
              e.target.src =
                `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}`
            }}
          />
        )}

        <div className="profile-mobile-info">
          <h5 className="profile-mobile-name">{user.name}</h5>
          <p className="profile-mobile-email">{user.email}</p>
        </div>
        <button
          className="profile-mobile-edit"
          onClick={() => navigate("/profile-settings")}
        >
          <Edit size={18} />
        </button>
      </div>

      {/* Mobile Stats */}
      <div className="profile-mobile-stats">
        <div className="profile-mobile-stat">
          <span className="profile-mobile-stat-value">{user.stats.orders}</span>
          <span className="profile-mobile-stat-label">Orders</span>
        </div>
        <div className="profile-mobile-stat">
          <span className="profile-mobile-stat-value">
            {user.stats.activeJobs}
          </span>
          <span className="profile-mobile-stat-label">
            Active Jobs
          </span>
        </div>
        <div className="profile-mobile-stat">
          <span className="profile-mobile-stat-value">{user.stats.reviews}</span>
          <span className="profile-mobile-stat-label">Reviews</span>
        </div>
      </div>

      {/* Switch to Customer */}
      {/* <div className="wp-extra-cards">
        <div className="wp-extra-card wp-extra-card--switch" onClick={() => setSwitchModal(true)}>
          <div className="wp-extra-card__left">
            <div className="wp-extra-card__icon" style={{ background: 'rgba(139,92,246,0.12)', color: '#8b5cf6' }}>
              <RefreshCw size={18} />
            </div>
            <div className="wp-extra-card__info">
              <span className="wp-extra-card__label">Switch to Light Mode</span>
              <span className="wp-extra-card__sub"> Switch to Light Mode For clean and minimal interface.</span>
            </div>
          </div>
          <ChevronRight size={16} className="wp-extra-card__arrow" />
        </div>
      </div> */}
    </>
  );
};

export default ProfileMobileHeader;